import { StaffPayScale } from '../../lib/types/models/staff-pay-scale/staff-pay-cale'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getStaffPayScale(id: number) {
  return restApiClient
    .url(constructApiUrl(API.staffPayScales.get.url, { id }))
    .get<StaffPayScale>()
}
